var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
var SnackbarContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSnackbarAlert: function () { },
    snackbarAlert: {
        message: '',
        type: 'success',
    },
});
export function SnackbarProvider(props) {
    var _a = useState({
        message: '',
        type: 'success',
    }), snackbarAlert = _a[0], setSnackbarAlert = _a[1];
    var handleSnackbarSet = function (snackBarAlert) {
        setSnackbarAlert(snackBarAlert);
    };
    var contextValue = useMemo(function () { return ({
        setSnackbarAlert: handleSnackbarSet,
        snackbarAlert: snackbarAlert,
    }); }, [snackbarAlert]);
    return _jsx(SnackbarContext.Provider, __assign({ value: contextValue }, { children: props.children }));
}
export var useSnackbar = function () { return useContext(SnackbarContext); };
